import { createSlice } from '@reduxjs/toolkit';

export const AuthReducer = createSlice({
  name: 'auth',
  initialState: {
    loginToken: null,
    loginRefreshToken: null,
    authToken: null,
    refreshToken: null,
    authTokenInitializeDate: null,
    companyPermissions: {},
    adminPermissions: null,
    adminCustomPermissions: null,
    profile: null,
    totalCompanies: 0,
    hasUnsavedChanges: false,
    unsavedChangedType: null,
    triggerSaveFormChanges: { trigger: false },
    breadcrumbs: { icon: null, items: [] },
    systemModules: [],
    customizedTableHeader: {},
  },
  reducers: {
    updateAuthState: (state, action) => {
      let data = state;
      data = { ...data, ...action.payload };
      state.loginToken = data.loginToken;
      state.loginRefreshToken = data.loginRefreshToken;
      state.authToken = data.authToken;
      state.refreshToken = data.refreshToken;
      state.authTokenInitializeDate = data.authTokenInitializeDate ?? null;
      state.companyPermissions = data.companyPermissions;
      state.adminPermissions = data.adminPermissions;
      state.adminCustomPermissions = data.adminCustomPermissions;
      state.profile = data.profile;
      state.customizedTableHeader = {};
    },
    updateAuthProfileState: (state, action) => {
      let profile = state.profile;
      profile = { ...profile, ...action.payload };
      state.profile = profile;
    },
    updateBreadCrumb: (state, action) => {
      state.breadcrumbs = action.payload.breadcrumbs;
    },
    updateSavedChanges: (state, action) => {
      state.hasUnsavedChanges = action.payload.hasUnsavedChanges;
      state.unsavedChangedType = action.payload.unsavedChangedType;
    },
    updateTriggerSaveFormChanges: (state, action) => {
      state.triggerSaveFormChanges = action.payload.triggerSaveFormChanges;
    },
    updateSystemModules: (state, action) => {
      state.systemModules = action.payload.systemModules;
    },
    updateTotalCompanies: (state, action) => {
      state.totalCompanies = action.payload.totalCompanies;
    },
    updateCustomizedTableHeader: (state, action) => {
      state.customizedTableHeader = {
        ...state.customizedTableHeader,
        [action.payload.type]: action.payload.customizedTableHeader,
      };
    },
    removeCustomizedTableHeader: (state, action) => {
      delete state.customizedTableHeader[action.payload.type];
    },
  },
});
